import axios from "axios";
import { Header, headers, user_Token } from "../Config";
import { url } from "../Config";

export const RegisterAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/auth/register-request`,
            method: 'POST',
            data: formData,
            headers: headers,
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const LoginAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/auth/login`,
            method: 'POST',
            data: formData,
            headers: headers,
        });
        return response;
    } catch (e) {
        return e;
    }
}

export const UpdatePasswordAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/user/changePassword`,
            method: 'POST',
            data: formData,
            headers: Header,
        });
        return response;
    } catch (e) {
        return e;
    }
}

export const UpdateGenderAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/user/update-gender`,
            method: 'POST',
            data: formData,
            headers: Header,
        });
        return response;
    } catch (e) {
        return e;
    }
}

export const UpdateProfileImageAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/user/update-profile-pic`,
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': `${user_Token}`
            },
        });
        return response;
    } catch (e) {
        return e;
    }
}


export const purchaseBookingAPI = async (formData) => {
    try {
        const response = await axios({
            url: `${url}api/user/purchase-booking`,
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': 'application/json',
                'authorization': `${user_Token}`
            },
        });
        return response;
    } catch (e) {
        return e;
    }
}
